import { useContext } from 'react';
import { AccessibilityContextType } from './accessibility-types';

// Context será importado do componente principal
let AccessibilityContext: React.Context<AccessibilityContextType | undefined>;

export const setAccessibilityContext = (context: React.Context<AccessibilityContextType | undefined>) => {
  AccessibilityContext = context;
};

export const useAccessibility = () => {
  if (!AccessibilityContext) {
    throw new Error('AccessibilityContext not initialized. Make sure AccessibilityProvider is imported first.');
  }
  
  const context = useContext(AccessibilityContext);
  if (!context) {
    throw new Error('useAccessibility must be used within an AccessibilityProvider');
  }
  return context;
}; 